import React from 'react';

export default function Lawenforcementinstructionscard({ embedded = false }) {
  const wrapperClass = embedded
    ? 'w-full flex items-center justify-center'
    : 'min-h-screen bg-gray-100 flex items-center justify-center p-4';
  const innerClass = embedded
    ? 'bg-sky-100 rounded p-2 max-w-2xl  w-[2.7in] md:w-full'
    : 'bg-sky-100 rounded-lg p-6 max-w-3xl w-full shadow-lg';
  const cardClass = embedded
    ? 'bg-white border-2 border-blue-700 rounded p-3'
    : 'bg-white border-2 border-blue-700 rounded-lg p-8';
  const titleClass = embedded
    ? 'text-center text-xl font-bold text-blue-600 mb-2'
    : 'text-center text-3xl font-bold text-blue-600 mb-6';
  const subtitleClass = embedded
    ? 'text-center text-blue-600 font-bold text-sm mb-2'
    : 'text-center text-blue-600 font-bold text-lg mb-6';
  const mainClass = embedded
    ? 'text-center text-gray-900 font-bold text-sm mb-2'
    : 'text-center text-gray-900 font-bold text-xl mb-4';
  const secondaryClass = embedded
    ? 'text-center text-gray-700 text-xs'
    : 'text-center text-gray-700 text-lg';

  return (
    <div className={wrapperClass}>
      <div className={innerClass}>
        {/* Title */}
        <h1 className={titleClass}>
          DRIVER WITH SPECIAL NEEDS
        </h1>
        
        {/* Inner white box */}
        <div className={cardClass}>
          {/* Subtitle */}
          <h2 className={subtitleClass}>
            LAW ENFORCEMENT AND FIRST RESPONDER'S INSTRUCTIONS:
          </h2>
          
          {/* Main instruction */}
          <p className={mainClass}>
            Driver may need extra time and simple, clear instructions during this stop.
          </p>
          
          {/* Secondary text */}
          <p className={secondaryClass}>
            Please see the enclosed document for more information.
          </p>
        </div>
      </div>
    </div>
  );
}